import { Component, Inject, OnInit } from '@angular/core';
import {DOCUMENT} from '@angular/common';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {faEye, faEyeSlash} from '@fortawesome/free-solid-svg-icons';
import {RegExpPatterns} from 'src/app/share/enums/regex-pattern.enum';
import {ForgotPasswordService} from 'src/app/share/services/forgot-password/forgot-password.service';
import * as CryptoJS from 'crypto-js';
import {environment} from 'src/environments/environment';
import {APPTYPES} from 'src/app/share/constants/common-constants';
import {AuthService} from '../auth/auth.service';
import {ActivatedRoute} from '@angular/router';
import {StorageService} from 'src/app/share/services/storage-service/storage.service';

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss'],
    standalone: false
})
export class ForgotPasswordComponent implements OnInit {
  repassword        : string = '';
  errorMessage      : string | undefined;
  registeredMail    : string = '';
  showForm1         : boolean = true;
  showForm2         : boolean = false;
  showForm3         : boolean = false;
  showPassword      : boolean = false;
  hide              : boolean = true;
  hide2             : boolean = true;
  disabled          : boolean = true;
  forgotPwdLoader   : boolean = false;
  typeBtn           : boolean = true;
  forgotpwdForm    !: FormGroup;
  registerForm2    !: FormGroup;
  otpvalue          : any;
  passwordValue     : any;
  customUrldata: any
  envType = environment?.envType || 'SDEX';
  appType = APPTYPES;
  isChangePassword: any;
  showErrorMessage  : any = {
                              show: false,
                              message: '',
                            };
  isLogoLoaded = false;                          

  protected readonly faEye = faEye;
  protected readonly faEyeSlash = faEyeSlash;

  constructor(
    private readonly fb: FormBuilder,
    private readonly forgotPasswordService: ForgotPasswordService,
    private readonly authService: AuthService,
    private readonly route: ActivatedRoute,
    private readonly storageService: StorageService,
    @Inject(DOCUMENT) private readonly document: Document
  ) { }

  ngOnInit(): void {
    this.isChangePassword = this.storageService.decrypt(this.route.snapshot.queryParamMap.get('isChangePassword'))
    this.initilizeForgotPwdForm();
    this.initilizeRegisterForm2();
    if (environment.envType !== this.appType.sdex) {
      //getting url data
        this.authService.getOrgLoginData()?.subscribe({
      next: (response: any) => {
        if(response?.data?.logo){
          this.customUrldata = response?.data;
        }
        this.isLogoLoaded = true;
        this.changeFavicon(this.customUrldata?.favIcon)
      },error:(err)=>{
        this.isLogoLoaded = true;
      }
    })
    }
  }
  validateOTP(event: any): void {
    const input = event.target.value;
    // Replace any non-numeric characters
    event.target.value = input.replaceAll(/\D/g, '');
  }

  changeFavicon(newIconPath: string) {
    const favicon = this.document.getElementById('favicon') as HTMLLinkElement;
    if (favicon) {
        favicon.href = newIconPath;
    }
  }

  initilizeForgotPwdForm(): void {
    this.forgotpwdForm = this.fb.group({
      emailAddress: [
        '',
        [Validators.required, Validators.pattern(RegExpPatterns.EmailPattern)],
      ],
    });
    this.registeredMail = '';
  }

  initilizeRegisterForm2(): void {
    this.registerForm2 = this.fb.group(
      {
        otp: ['', [Validators.required]],
        password: [
          '',
          [
            Validators.required,
            Validators.pattern(RegExpPatterns.PasswordPattern),
          ],
        ],
        repassword: ['', [Validators.required, this.passwordsMatchValidatorForForm2]],
      }
    );
  }

  passwordsMatchValidatorForForm2(formGroup: FormGroup) {
    const password = formGroup.get('password')?.value;
    const repassword = formGroup.get('repassword')?.value;
    if (password === repassword) {
      formGroup.get('repassword')?.setErrors(null);
    } else {
      formGroup.get('repassword')?.setErrors({ passwordsMismatch: true });
    }
  }

  onForgotpwd() {
    this.forgotPwdLoader = true;
    this.forgotPasswordService
      .forgotPassword(this.forgotpwdForm?.value)
      .subscribe({
        next: (res) => {
          this.registeredMail =
            this.forgotpwdForm.controls?.['emailAddress']?.value;
          this.showForm1 = false;
          this.showForm2 = true;
          setTimeout(() => {
            this.disabled = false
          }, 900000);
          this.forgotPwdLoader = false;
        },
        error: (error: any) => {
          this.errorMessage = error?.error?.error?.message;
          this.forgotPwdLoader = false;
        }
      }
      );
  }

  resendOtp() {
    this.forgotPwdLoader = true;
    this.forgotPasswordService
      .forgotPassword(this.forgotpwdForm.value)
      .subscribe({
        next: (res) => {
          this.registeredMail =
            this.forgotpwdForm.controls?.['emailAddress'].value;
          this.disabled = true;
          setTimeout(() => {
            this.disabled = false
          }, 900000);
          this.forgotPwdLoader = false;
        },

        error: (error) => {
          this.errorMessage = error?.error?.error?.message;
          this.forgotPwdLoader = false;
        }
      }
      );
  }

  onVerify2() {
    this.forgotPwdLoader = true;
    this.otpvalue = this.registerForm2?.controls['otp'].value;
    this.passwordValue = CryptoJS.SHA256(this.registerForm2?.controls['password'].value).toString(CryptoJS.enc.Hex);
    const payload = {
      emailAddress: this.registeredMail,
      otp: this.otpvalue,
      password: this.passwordValue,

    };
    this.forgotPasswordService.changePassword(payload)?.subscribe({
      next: (res) => {
        this.showForm2 = false;
        this.showForm3 = true;
        this.showErrorMessage.show = true;
        this.forgotPwdLoader = false;
      },
      error: (error: any) => {
        this.showErrorMessage = {
          show: true,
          message: error?.error?.error?.message
            ? error?.error?.error?.message
            : 'Unable to submit Please try again',
        };
        this.forgotPwdLoader = false;
      }
    });
  }

  getInputValue(event: any) {
    if (this.errorMessage) {
      this.errorMessage = '';
    }
  }
}
